import { combineReducers } from "redux";
import roles from "../features/admin/role-management/role/Slice";


const rolemanagement = combineReducers({
    roles: roles
})


export default rolemanagement;